module.exports = __webpack_public_path__ + "teqbahn-assets/media/24.e90bf168.png";